import React, { useContext, useState } from "react";
import QuickActionPopup, { QuickActionPopupProps } from "../../../quick-action-popup/QuickActionPopup";
import { useDeactivateLoad, useEventTrackerService } from "@vahak/core/dist/_services";
import { toast } from "@vahak/core/dist/components/toast/toast";
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types";
import { VerticalFlex } from "@vahak/core-ui/dist/layout/Flex";
import IconWrapper from "@vahak/core-ui/dist/components/IconWrapper";
import WarningRed from "@vahak/core/dist/standard-icons/warning-red.svg";
import JsonForm from "@vahak/core-ui/dist/components/common/JsonForm/JsonForm";
import { GA4EventNamesAdminConsole } from "@vahak/core/dist/constants";
import { AppContext } from "@vahak/core/dist/app-context";

interface AdminDisableLoadWithRemarksProps extends Pick<QuickActionPopupProps, "isOpen" | "onToggle"> {
    loadId: number;
    onRefetch?: Function;
}

const DisableLoadWithRemarks = ({ loadId, isOpen, onToggle, onRefetch }: AdminDisableLoadWithRemarksProps) => {
    const { mutateAsync: deactivateLoad } = useDeactivateLoad();
    const [csRemarksText, setCsRemarksText] = useState("");

    //Events
    const { sendGAandMoEngageEvent } = useEventTrackerService();
    const { name } = useContext(AppContext);

    const rejectLoadCta = () => {
        return new Promise(async (resolve) => {
            deactivateLoad(
                {
                    loadId: loadId,
                    userFeedback: `${csRemarksText} (Updated by ${name})`
                },
                {
                    onSuccess: () => {
                        toast.success("Load deactivated");
                        sendGAandMoEngageEvent({
                            name: GA4EventNamesAdminConsole.TSO_LOAD_DETAILS_SCREEN.removed_from_market,
                            data: {
                                load_id: loadId
                            }
                        });
                    },
                    onError: (err: ApiErrorResponseType) => {
                        toast.error(err?.message || "Load Not deactivated");
                    },
                    onSettled: () => {
                        resolve(0);
                        onToggle?.();
                        onRefetch?.();
                    }
                }
            );
        });
    };

    return (
        <>
            {isOpen && (
                <QuickActionPopup
                    isOpen
                    ctaText={"Deactivate Load"}
                    ctaAction={rejectLoadCta}
                    secondaryCtaAction={onToggle}
                    onToggle={onToggle}
                    secondaryCtaText={"Go Back"}
                    titleText="Deactivate Load"
                    description={
                        <VerticalFlex alignItems="center" justifyContent="center" gap={12} margin={20}>
                            <IconWrapper width={120} height={120}>
                                <WarningRed />
                            </IconWrapper>
                            Are you sure you want to deactivate this load ?
                            <JsonForm
                                formData={[
                                    {
                                        formInputType: "text-area",
                                        name: "cs-remarks",
                                        onChange: (e) => setCsRemarksText(e.target.value),
                                        width: 300,
                                        required: true,
                                        showCharacterCount: true,
                                        helpMsg: "Min 5 char",
                                        length: 200,
                                        value: csRemarksText
                                    }
                                ]}
                            />
                        </VerticalFlex>
                    }
                    commonCtaProps={{
                        isRounded: true,
                        disabled: csRemarksText.trim().length < 5
                    }}
                />
            )}
        </>
    );
};

export default DisableLoadWithRemarks;
